import { useNavigate } from "react-router-dom";
let fractions = [
	{
		html: "",
		text: "",
	},
	{
		html: "<sup>1</sup>&frasl;<sub>16</sub>",
		text: "1/16",
	},
	{
		html: "<sup>1</sup>&frasl;<sub>8</sub>",
		text: "1/8",
	},
	{
		html: "<sup>3</sup>&frasl;<sub>16</sub>",
		text: "3/16",
	},
	{
		html: "<sup>1</sup>&frasl;<sub>4</sub>",
		text: "1/4",
	},
	{
		html: "<sup>5</sup>&frasl;<sub>16</sub>",
		text: "5/16",
	},
	{
		html: "<sup>3</sup>&frasl;<sub>8</sub>",
		text: "3/8",
	},
	{
		html: "<sup>7</sup>&frasl;<sub>16</sub>",
		text: "7/16",
	},
	{
		html: "<sup>1</sup>&frasl;<sub>2</sub>",
		text: "1/2",
	},
	{
		html: "<sup>9</sup>&frasl;<sub>16</sub>",
		text: "9/16",
	},
	{
		html: "<sup>5</sup>&frasl;<sub>8</sub>",
		text: "5/8",
	},
	{
		html: "<sup>11</sup>&frasl;<sub>16</sub>",
		text: "11/16",
	},
	{
		html: "<sup>3</sup>&frasl;<sub>4</sub>",
		text: "3/4",
	},
	{
		html: "<sup>13</sup>&frasl;<sub>16</sub>",
		text: "13/16",
	},
	{
		html: "<sup>7</sup>&frasl;<sub>8</sub>",
		text: "7/8",
	},
	{
		html: "<sup>15</sup>&frasl;<sub>16</sub>",
		text: "15/16",
	},
	{
		html: "<sup>1</sup>&frasl;<sub>1</sub>",
		text: "1/1",
	},
];

export function Render_status(p) {
	let does_it_work = p.does_it_work;

	let button_copy = "Bay";
	if (p.button_copy != undefined) button_copy = p.button_copy;

	return (
		<>
			{does_it_work && (
				<div className="status">
					<p className="pass">Valid</p>
					<span className="button" onClick={() => document.getElementById("save_overlay").classList.add("show")}>
						Save <strong>{button_copy}</strong>
					</span>
				</div>
			)}

			{!does_it_work && (
				<div className="status">
					<p>Measurements not valid</p>
					<div className="info_button">
						<div className="icon"></div>
						<div className="tool_tip">
							<h4>
								Number <strong>Checker</strong>
							</h4>
							<p>
								Your number are <strong>not currently valid</strong>, please enter numbers within boxes provided.
							</p>
							<h4>
								Measuring <strong>tips</strong>
							</h4>
							<ul>
								<li>Use a metal tape measure and ensure you have help.</li>
								<li>Measure wall at height the pole will be fitted.</li>
								<li>Mark measuring points lightly with pencil to ensure consistency.</li>
								<li>Measure wall dimensions not pole dimensions.</li>
							</ul>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export function load_porjects() {
	let the_projects_raw = localStorage.getItem("the_projects");
	let the_projects = [];
	if (the_projects_raw != null) the_projects = JSON.parse(the_projects_raw);

	return the_projects;
}

export function set_new_project(new_title) {
	let the_projects = load_porjects();
	the_projects.push({
		project_title: new_title,
		bays: [],
	});

	//console.log(the_projects);

	localStorage.setItem("the_projects", JSON.stringify(the_projects));

	return the_projects;
}

export function set_new_bay(new_bay_title, bay_type, the_summary, project_id) {
	let the_projects = load_porjects();

	the_projects[project_id].bays.push({
		bay_title: new_bay_title,
		bay_type: bay_type,
		bay_summary: the_summary,
	});

	localStorage.setItem("the_projects", JSON.stringify(the_projects));
	return the_projects;
}

export function Render_save_overlay(p) {
	let the_projects = load_porjects();
	const navigate = useNavigate();

	function close_overlay() {
		document.getElementById("save_overlay").classList.remove("show");
	}

	function go_to_step_1() {
		go_to_step("1");
		p.force_update(Date.now());
	}

	function go_to_step_2() {
		let select = document.getElementById("step_1_select");

		//console.log(select.value);

		if (select.value == "select") return;

		if (select.value == "new") {
			go_to_step("2");
			return;
		}

		document.getElementById("step_3_project_selection").innerHTML = the_projects[select.value].project_title;
		document.getElementById("step_3_project_id").value = select.value;
		go_to_step("3");
	}

	function step_2_create() {
		let new_title = document.getElementById("step_2_title").value;

		if (new_title == "") {
			//console.log("Name Empty");
			return;
		}

		//TODO Check if this project name is already is use.

		the_projects = set_new_project(new_title);
		document.getElementById("step_3_project_selection").innerHTML = new_title;
		document.getElementById("step_3_project_id").value = the_projects.length - 1;

		go_to_step("3");
	}

	function step_3_save() {
		let bay_title = document.getElementById("step_3_bay_title");
		let project_id = document.getElementById("step_3_project_id").value;

		if (bay_title.value == "") {
			bay_title.classList.add("error");
			return;
		}

		the_projects = set_new_bay(bay_title.value, p.bay_type, p.the_summary, project_id);
		navigate("/app/bay-checker/", { replace: true });
	}

	function go_to_step(step) {
		document.querySelector(".overlay_step.open").classList.remove("open");
		document.getElementById("step_" + step).classList.add("open");
	}

	return (
		<div id="save_overlay" className="save_overlay">
			<div className="title_close">
				<h4>
					Save <strong>Your Bay</strong>
				</h4>
				<span onClick={() => close_overlay()}></span>
			</div>

			<div id="step_1" className="overlay_step open">
				<h5>
					Select <strong>Project</strong>
				</h5>
				<select
					id="step_1_select"
					onChange={(e) => {
						let step_1_next = document.getElementById("step_1_next");
						if (e.target.value == "select") step_1_next.classList.add("dissable");
						else step_1_next.classList.remove("dissable");
					}}
				>
					<option value="select">- Select -</option>
					<option value="new">- Create New Project -</option>
					{the_projects.map((project, project_id) => {
						return (
							<option key={"project_id_" + project_id} value={project_id}>
								{project.project_title}
							</option>
						);
					})}
				</select>
				<div className="actions">
					<span className="button light" onClick={() => close_overlay()}>
						Cancel
					</span>
					<span id="step_1_next" className="button" onClick={() => go_to_step_2()}>
						Select
					</span>
				</div>
			</div>

			<div id="step_2" className="overlay_step">
				<h5>
					Your <strong>Project</strong> Title
				</h5>
				<p>Create a new project to save your bay within.</p>
				<input id="step_2_title" placeholder="Project Name" maxLength="35" />
				<div className="actions">
					<span className="button light" onClick={() => go_to_step_1()}>
						Go Back
					</span>
					<span id="step_2_create" className="button" onClick={() => step_2_create()}>
						Create
					</span>
				</div>
			</div>

			<div id="step_3" className="overlay_step">
				<h5>
					Saving <strong>Within</strong>
				</h5>

				<div className="project_selection">
					<p id="step_3_project_selection">Selection Title</p>
					<span onClick={() => go_to_step_1()}>Change</span>
				</div>

				<h5>
					Your <strong>Bay</strong> Title
				</h5>

				<p>Save your window within a the selected project.</p>
				<div className="error_wrapper">
					<input
						id="step_3_bay_title"
						placeholder="Bay Name"
						autoComplete="off"
						maxLength="35"
						onChange={(e) => {
							e.target.classList.remove("error");
						}}
					/>
					<p className="hidden_error">Required</p>
				</div>
				<input type="hidden" id="step_3_project_id" />

				<div className="actions">
					<span className="button light" onClick={() => go_to_step_1()}>
						Go Back
					</span>
					<span id="step_3_save" className="button" onClick={() => step_3_save()}>
						Save
					</span>
				</div>
			</div>
		</div>
	);
}

export function Render_measurtement(p) {
	let measurtement_type = localStorage.getItem("measurtement_type");

	let time_out = false;

	return (
		<div
			id={"render_measurtement_" + p.measurtement_name}
			className={"render_measurtement " + measurtement_type}
			onFocus={() => {
				clearTimeout(time_out);
				time_out = false;

				let path_one = document.querySelector("svg .g_" + p.measurtement_name[0]);
				let path_two = document.querySelector("svg .g_" + p.measurtement_name[1]);
				let wrapper = document.getElementById("render_measurtement_" + p.measurtement_name);

				path_one.classList.add("current");
				path_two.classList.add("current");
				wrapper.classList.add("show_range");
			}}
			onBlur={() => {
				let path_one = document.querySelector("svg .g_" + p.measurtement_name[0]);
				let path_two = document.querySelector("svg .g_" + p.measurtement_name[1]);

				path_one.classList.remove("current");
				path_two.classList.remove("current");
				time_out = setTimeout(function () {
					let wrapper = document.getElementById("render_measurtement_" + p.measurtement_name);
					if (wrapper) wrapper.classList.remove("show_range");
				}, 100);
			}}
		>
			<label>
				<p>
					<span>{p.measurtement_name[0].toUpperCase()}</span>-<span>{p.measurtement_name[1].toUpperCase()}</span>
				</p>
				<input
					type="number"
					id={"number_" + p.measurtement_name}
					max={99999}
					min={0}
					onChange={(e) => {
						let { value, min, max } = e.target;
						let clean_number = value.replace(/[^0-9]/g, "");
						let new_number = Math.max(Number(min), Math.min(Number(max), Number(clean_number)));

						p.set_measurtement(new_number);
					}}
					onFocus={(e) => {
						if (e.target.value === "0") {
							e.target.value = "";
							e.target.value = "0";
						}
					}}
					value={p.measurtement}
				/>{" "}
				<span className="measurtement_type">
					<span className="fraction" id={"fraction_" + p.measurtement_name}></span> {measurtement_type}
				</span>
			</label>

			<div className="range">
				<input
					id={"range_" + p.measurtement_name}
					className="inches_range"
					type="range"
					name="volume"
					min="0"
					max="16"
					list="markers"
					defaultValue="0"
					onChange={(e) => {
						let fraction = document.getElementById("fraction_" + p.measurtement_name);
						if (e.target.value == 0) {
							fraction.classList.remove("open");
							fraction.innerHTML = "";
						} else {
							fraction.classList.add("open");
							fraction.innerHTML = fractions[e.target.value].html;
						}
					}}
					onTouchEnd={(e) => p.force_update(Date.now())}
					onMouseUp={(e) => p.force_update(Date.now())}
				/>
			</div>
		</div>
	);
}

export function Render_summary(p) {
	let measurtement_type = localStorage.getItem("measurtement_type");

	let fraction = 0;
	let output_fraction = "";
	if (document.getElementById("range_" + p.the_key)) {
		fraction = parseInt(document.getElementById("range_" + p.the_key).value);
	}

	let measurtement_mm = p.measurtement_mm;
	if (isNaN(measurtement_mm)) measurtement_mm = 0;
	let measurtement_in = measurtement_mm / 25.4;

	if (measurtement_type === "in") {
		let fraction_in_mm = 0;
		if (fraction != 0) {
			fraction_in_mm = (25.4 / 16) * fraction;
			output_fraction = fractions[fraction].text;
		}
		measurtement_in = measurtement_mm;
		measurtement_mm = measurtement_in * 25.4;
		measurtement_mm = Math.round(measurtement_mm + fraction_in_mm);
	}
	if (measurtement_type === "mm") {
		if (measurtement_mm > 0) {
			let frantion_num = Math.round((measurtement_mm % 25.4) * (16 / 25.4));
			if (frantion_num === 16) {
				measurtement_in += 1;
				frantion_num = 0;
			}
			output_fraction = fractions[frantion_num].text;
		}

		measurtement_in = Math.floor(measurtement_in);
	}

	return (
		p.the_key[0].toUpperCase() +
		"-" +
		p.the_key[1].toUpperCase() +
		" - " +
		measurtement_mm +
		"mm (" +
		measurtement_in +
		(output_fraction ? " " + output_fraction : "") +
		'") \n'
	);
}

export function reduce(numerator, denominator) {
	var gcd = function gcd(a, b) {
		return b ? gcd(b, a % b) : a;
	};
	gcd = gcd(numerator, denominator);
	return [numerator / gcd, denominator / gcd];
}

function get_measurtement_in_mm(i, measurtement_name) {
	if (localStorage.getItem("measurtement_type") === "mm") return i;

	let fraction = document.getElementById("range_" + measurtement_name).value;
	return Math.round(i * 25.4 + 1 / fraction);
}

export function Toggle_measurtement_type(p) {
	let the_class = localStorage.getItem("measurtement_type") == "in" ? "type_in" : "type_mm";

	return (
		<div
			className={"toggle_measurtement " + the_class}
			onClick={() => {
				if (localStorage.getItem("measurtement_type") == "mm") localStorage.setItem("measurtement_type", "in");
				else localStorage.setItem("measurtement_type", "mm");
				p.force_update(Date.now());
			}}
		>
			<div>mm</div>
			<div>inches</div>
		</div>
	);
}

export function check_one_bend_bay(ac, ab, bc) {
	var angle = findAngleFromOppositeSideAndOtherSidesOfTriangle(ac, ab, bc);
	var angleDegrees = angle * (180 / Math.PI);

	if (isNaN(angle)) return false;
	if (angleDegrees < 75.0 || angleDegrees > 160.0) return false;

	//console.log("pass " + angleDegrees);
	return true;
}

export function check_two_bend_bay(cd, ab, bc, ac, ad, bd) {
	let tolerance = calculateTolerance(ad);

	let angleB = findAngleFromOppositeSideAndOtherSidesOfTriangle(ac, ab, bc);
	if (isNaN(angleB)) return false;

	let angleC = findAngleFromOppositeSideAndOtherSidesOfTriangle(bd, bc, cd);
	if (isNaN(angleC)) return false;

	//console.log("angleB: " + angleB + " - angleC: " + angleC);

	var angleB1 = findAngleFromOppositeSideAndAnotherAngleAndSideOfTriangle(cd, bd, angleC);
	var angleC1 = findAngleFromOppositeSideAndAnotherAngleAndSideOfTriangle(ab, ac, angleB);
	var angleB2 = angleB - angleB1;
	var angleC2 = angleC - angleC1;
	var AD1 = findSideFromOppositeAngleAndTheOtherSidesOfTriangle(angleB2, ab, bd);
	var AD2 = findSideFromOppositeAngleAndTheOtherSidesOfTriangle(angleC2, ac, cd);

	//console.log("tolerance: " + tolerance + " AD1: " + AD1);
	if (Math.abs(AD1 - ad) > tolerance || Math.abs(AD2 - ad) > tolerance) {
		return false;
	}

	return true;
}

export function check_continuous_curve_bay(ab, bc, ac) {
	let tolerance = calculateTolerance(ac);

	if (ab < 400) return false;
	if (bc < 400) return false;
	if (ac < 400) return false;

	if (ab + bc < ac + tolerance) return false;
	if (ac + ab < bc + tolerance) return false;
	if (bc + ac < ab + tolerance) return false;

	/*
	if (Math.abs(ab - bc) > tolerance) {
		return false;
	}

	let angleB = findAngleFromOppositeSideAndOtherSidesOfTriangle(ac, ab, bc);
	if (isNaN(angleB)) {
		return false;
	}

	let angleB2 = angleB / 2.0;

	let BmidAC1 = Math.cos(angleB2) * ab;
	let BmidAC2 = Math.cos(angleB2) * bc;
	let BmidAC3 = ac / 2.0 / Math.tan(angleB2);

	if (Math.abs(BmidAC1 - BmidAC3) > tolerance || Math.abs(BmidAC2 - BmidAC3) > tolerance) {
		return false;
	}
	*/

	return true;
}

export function check_four_bend_bay(ab, bc, cd, de, ef, af, ae, bf, bd, be, ce) {
	let tolerance = calculateTolerance(af);

	let angleB = findAngleFromOppositeSideAndOtherSidesOfTriangle(ae, ab, be);
	if (isNaN(angleB)) return false;

	let angleC = findAngleFromOppositeSideAndOtherSidesOfTriangle(bd, bc, cd);
	if (isNaN(angleC)) return false;

	let angleD = findAngleFromOppositeSideAndOtherSidesOfTriangle(ce, cd, de);
	if (isNaN(angleD)) return false;

	let angleE = findAngleFromOppositeSideAndOtherSidesOfTriangle(bf, be, ef);
	if (isNaN(angleE)) return false;

	let angleB1 = findAngleFromOppositeSideAndAnotherAngleAndSideOfTriangle(ef, bf, angleE);
	let angleE1 = findAngleFromOppositeSideAndAnotherAngleAndSideOfTriangle(ab, ae, angleB);
	let angleC1 = findAngleFromOppositeSideAndAnotherAngleAndSideOfTriangle(de, ce, angleD);
	let angleD1 = findAngleFromOppositeSideAndAnotherAngleAndSideOfTriangle(bc, bd, angleC);

	let angleB2 = angleB - angleB1;
	let angleE2 = angleE - angleE1;
	let angleC2 = angleC - angleC1;
	let angleD2 = angleD - angleD1;

	let AF1 = findSideFromOppositeAngleAndTheOtherSidesOfTriangle(angleB2, ab, bf);
	let AF2 = findSideFromOppositeAngleAndTheOtherSidesOfTriangle(angleE2, ae, ef);
	let BE1 = findSideFromOppositeAngleAndTheOtherSidesOfTriangle(angleC2, bc, ce);
	let BE2 = findSideFromOppositeAngleAndTheOtherSidesOfTriangle(angleD2, bd, de);

	if (Math.abs(AF1 - af) > tolerance || Math.abs(AF2 - af) > tolerance) return false;
	if (Math.abs(BE1 - be) > tolerance || Math.abs(BE2 - be) > tolerance) return false;

	return true;
}

//// helper functions

var continuousCurveBmidAC;

function calculateTolerance(criticalSideLength) {
	if (criticalSideLength < 3000.0) return parseInt(0.005 * criticalSideLength);
	if (criticalSideLength < 5000.0) return parseInt(0.007 * criticalSideLength);

	return parseInt(0.008 * criticalSideLength);
}

function DegToRad(degrees) {
	return degrees * (Math.PI / 180);
}

function findAngleFromOppositeSideAndOtherSidesOfTriangle(oppositeSide, sideX, sideY) {
	var cosAngle = (sideX * sideX + sideY * sideY - oppositeSide * oppositeSide) / (2 * sideX * sideY);
	return Math.acos(cosAngle);
}

function findAngleFromOppositeSideAndAnotherAngleAndSideOfTriangle(sideX, sideY, angleY) {
	var sinAngle = (sideX * Math.sin(angleY)) / sideY;
	return Math.asin(sinAngle);
}

function findSideFromOppositeAngleAndTheOtherSidesOfTriangle(oppositeAngle, sideX, sideY) {
	return Math.sqrt(sideX * sideX + sideY * sideY - 2 * sideX * sideY * Math.cos(oppositeAngle));
}
